import axios from 'axios'

const blipApi = axios.create({
    baseURL: 'https://msging.net/commands',
    headers: {'Authorization' : 'Key Y2hhdGJvdGN5YmVyYnVsbGV2aW9sZW5jaWE6NEY0WjU5eDQyWDFqUGRGejR4Ums=', 'Content-Type': "application/json"}
})

export default blipApi